import React, { useEffect, useState } from 'react';
import { Bubble, Button, Dropdown, Input, SearchBox } from 'tea-component';
import './index.scss';
import BubbleCommon from '@/pages/opinion/components/BubbleCommon';
import { useIntl } from 'umi';

const SortBySelect = (props: any) => {
  const {
    onChange,
    valueKey,
    valueType,
    defaultValue = '',
    defaultParams: { btnTextPrefix = '' },
    // errorConfig 先简单支持单个
    errorConfig = {
      max: Infinity,
      min: -Infinity,
      tip: '',
    },
    tipsMap = null,
  } = props;

  const { formatMessage } = useIntl();
  const [value, setValue] = useState(defaultValue);
  const [input, setSearch] = useState(defaultValue);
  const [error, setError] = useState('');

  useEffect(() => {
    if (defaultValue !== value) {
      setValue(defaultValue);
      setSearch(defaultValue);
    }
  }, [defaultValue]);

  const hasError = (value) => {
    if (value.trim?.() === '') return false;

    return isNaN(value) || value > errorConfig.max || value < errorConfig.min;
  };

  const handleSearchChange = (value) => {
    setSearch(value);
    if (hasError(value)) {
      setError(errorConfig.tip);
    } else {
      setError('');
    }
  };
  const handleSearchClear = () => {
    setSearch('');
    setError('');
  };
  const handleSearch = (value, close) => {
    console.log('handleSearch', value);
    if (hasError(value)) {
      setError(errorConfig.tip);
      return;
    } else {
      setError('');
    }

    if (value.trim?.() === '') {
      setValue('');
      onChange?.(valueKey, '');
    } else {
      let newValue = Number(value);

      if (valueType === 'integer') {
        newValue = parseInt(value);
      }

      setValue(newValue);
      onChange?.(valueKey, newValue);
    }

    close();
  };

  return (
    <>
      <BubbleCommon tipsMap={tipsMap} placement={'top'} showIcon={false}>
        <>
          <Dropdown
            size="m"
            destroyOnClose={false}
            button={
              <div className="select-button">
                <span className="select-button-text">{btnTextPrefix} </span>
                <span
                  className={`select-button-value ${
                    value.trim?.() === '' ? 'select-button-value--none' : ''
                  }`}
                >
                  {value.trim?.() === ''
                    ? formatMessage({ id: 'None' })
                    : value}
                </span>
              </div>
            }
            appearance="button"
            clickClose={false}
            className="dbo-inputfactory-wrapper"
          >
            {(close) => (
              <div
                style={{ width: 231 }}
                className={`dbo-inputfactory ${error ? 'error' : ''}`}
              >
                <Input
                  value={input}
                  onChange={handleSearchChange}
                  placeholder={formatMessage({ id: 'Input Number' })}
                />
                {error ? (
                  <div className="text-error">{error}</div>
                ) : input.trim?.() === '' ? (
                  <div className="text-warning">{errorConfig.tip}</div>
                ) : null}

                <div className="dbo-inputfactory-btngroup">
                  <Button
                    type="primary"
                    onClick={() => {
                      handleSearch(input, close);
                    }}
                  >
                    {formatMessage({ id: 'Confirm' })}
                  </Button>
                  <Button
                    onClick={() => {
                      close();
                    }}
                  >
                    {formatMessage({ id: 'Cancel' })}
                  </Button>
                </div>
              </div>
            )}
          </Dropdown>
        </>
      </BubbleCommon>
    </>
  );
};

export default SortBySelect;
